﻿import { BaseWidget } from "../BaseWidget";
import { AnyElement, IMuWidget } from "../MuWidget/IMuWidget";
import { MessagePath } from "../Types";

export class Repeater extends BaseWidget {
    canRemove() : boolean {
        if (this.minCount == 0) return true;
        const c = this.getItemCount();
        return c > this.minCount;
    }
    
    canAdd() : boolean {
        if (this.maxCount == null) return true;
        const c = this.getItemCount();
        return c < this.maxCount;
    }
    
    public minCount : Number = 0;

    public maxCount : Number|null = null;

    public bindFieldOnly : string|null;

    private getItemCount() :  number {
        return (this.ui.items as HTMLElement).childElementCount;
    }

    bAddItem_click() {
        this.addItem();
    }

    override updateForm() {
        const c = this.getItemCount();
        for (var i = c; i < this.minCount; i++) this.addItem();
    }

    override muBindData(arr: any[]) {
        if (arr == null) arr = [];
        this.ui.items.innerHTML = "";
        for(let item of arr) {
            if (this.bindFieldOnly) {
                const v = item;
                item = {};
                item[this.bindFieldOnly] = v;
            }
            this.addItem(item);
        }
    }

    override muFetchData(): any[] {
        return this.muGetChildWidgets<IMuWidget>("items")
            .map(w => this.bindFieldOnly
                ? w.muFetchData()[this.bindFieldOnly]
                : w.muFetchData()
            );
    }

    addItem(item: any = null) {
        if (this.canAdd()) {
            const widget = this.muWidgetFromTemplate("item", "items");
            if (item) widget.muBindData(item);
            if (widget.ui.bRemoveItem !== null) this.hideElement(widget.ui.bRemoveItem, this.muGetChildWidgets(this.ui.items).length > this.minCount);
            if (this.ui.bAddItem !== null && this.maxCount !== null) this.hideElement(this.ui.bAddItem, this.muGetChildWidgets(this.ui.items).length < this.maxCount);
            this.afterAddItem(widget, item);
        } else alert("Nelze přidat položku");
    }

    afterAddItem(widget, item) { }

    override findElementByPath(path : MessagePath) : AnyElement {
        const el = this.ui.items.children[path[0]];
        if (path.length > 1)
        {
            return ((el as any).widget as BaseWidget).findElementByPath(path.slice(1));
        } else {
            return el;
        }
    }

    clearItems(container: string | AnyElement, lastIndex: number = -1) {
        if (lastIndex + 1 >= this.minCount) {
            const childWidgets = this.muGetChildWidgets(container);
            const length = childWidgets.length;

            for (let i: number = length - 1; i > lastIndex; i--) {
                childWidgets[i].muRemoveSelf();
            }
        }
    }

    changeMinCount(newValue: Number) {
        const items: RepeaterItem[] = this.muGetChildWidgets(this.ui.items);
        this.minCount = newValue;

        if (items.length > 0)
            for (let i = 0; i < items.length; i++)
                this.hideElement(items[i].ui.bRemoveItem, i >= newValue);
    }

    changeMaxCount(newValue: Number) {
        const items: RepeaterItem[] = this.muGetChildWidgets(this.ui.items);
        this.maxCount = newValue;

        this.hideElement(this.ui.bAddItem, items.length < newValue);
    }

}

export class RepeaterItem extends BaseWidget {
    bRemoveItem_click() {
        const repeater = this.muParent as Repeater;

        if (!repeater.canRemove()) {
            alert("Položku není možné odebrat");
            return;
        }
        if (confirm("Chcete odebrat tuto položku?")) {
            this.beforeRemove();
            this.hideElement((this.muParent as Repeater).ui.bAddItem, true)
            this.muRemoveSelf();
        }
    }

    beforeRemove() {

    }
}

